export * from './Chip';
export { default } from './Chip';
//# sourceMappingURL=index.js.map